import styled from 'styled-components';
import { Alert as AlertBase } from '@mui/lab';
import { space } from '../../style/utils';

const Alert = styled(AlertBase)`
  max-width: fit-content;
  text-wrap: wrap;
  color: ${({ theme }) => theme.palette.content.primary};

  .MuiAlert-icon {
    color: ${({ theme }) => theme.palette.content.primary};
  }
  margin: ${space('sm')};
`;

export default Alert;
